import appBackups from "../../views/appRoutes/backups.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "emergency_handling";
  const params = ["page", "limit", "status", "date", "captain", "bus_type"];

  $stateProvider.state("backups", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appBackups,
      },
    },
    reloadOnSearch: false,
    data: { title: "Backups" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/backups/backups.urls.js